import axios from "axios";

export const postAnalytics = async (blob, values) => {
  await axios.post(`/api/analytics/interaction`, { blob, values });
};
